<template>
    <div>
        <!-- 移动端头部 -->
        <ul class="mob_header">
            <li class="mob_header_item" @click="goPath(item)" v-for="(item,index) in btnList" :key="index">
                <img :src="item.img" />
                <div>{{ item.name }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'MobHeader',

    data() {
        return {
            btnList:[
                {
                    img:require('../static/imgs/jiuhucheambulance9.png'),
                    name:'出诊安排',
                    path:'/center'
                },{
                    img:require('../static/imgs/yuyuejilu.png'),
                    name:'预约挂号',
                    path:'/center'

                },{
                    img:require('../static/imgs/shouji2-mianxing.png'),
                    name:'智慧就医',
                    path:'/center'
                },{
                    img:require('../static/imgs/xinxiang-fanbai.png'),
                    name:'院长信箱',
                    path:'/center'
                },{
                    img:require('../static/imgs/dakaixinxi.png'),
                    name:'信息公开',
                    path:'/center'
                },{
                    img:require('../static/imgs/24gf-telephone3.png'),
                    name:'投诉电话',
                    path:'/center'
                },
            ]
        };
    },

    mounted() {
        
    },

    methods: {
        goPath(item){
            console.log(item.path)
            this.$router.push(item.path)
        }
    },
};
</script>

<style lang="scss" scoped>
.mob_header{
    width: 4.5rem;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.mob_header_item{
    width: 1.3rem;
    height: 1.3rem;
    background-color: #F3FAFF;
    position: relative;
    margin-top: 20px;
}
.mob_header_item img{
    position: absolute;
    left: 35%;
    top: 22%;
    width: 0.4rem;
    height: 0.35rem;
}
.mob_header_item:nth-child(3) img{
    width: 0.3rem;
    height: 0.4rem;
    position: absolute;
    left: 38%;
}
.mob_header_item div{
    font-size: 0.15rem;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 0.4rem;
    background-color: #005FAF;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;

}

</style>